import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";
const initState = {
    profilePic: null,
    firstName: "",
    lastName: "",
    userName: "",
    phone: "",
    emailAddress: "",
    gender: "",
    addressLineId: "",
    organizationId: "",
};

export const multiRowGroupFormConfig = {
    name: "User Form",
    initialState: initState,
    section: [
        {
            title: "Profile Section",
            row: {},
            style: {
                sectionStyle: "col-lg-4 col-md-2",
            },
            wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
            fields: [
                {
                    id: "singleSkill",
                    label: "Skill",
                    Field_Name: "skill",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "singleSkill",
                    fieldSetting: {
                        placeholder: "Please Select A Skill",
                        allowSpace: true,
                        options: [
                            { label: "City 1", value: 1 },
                            { label: "City 2", value: 2 },
                            { label: "City 3", value: 3 },
                        ],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-left-0",
                    },
                },
                {
                    id: "skills",
                    label: "Skills : ",
                    Field_Name: "skills",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "skills",
                    fieldSetting: {
                        placeholder: "Please Select Skills",
                        isMultiSelect: true,
                        allowSpace: true,
                        options: [
                            { label: "React", value: 1 },
                            { label: "Node", value: 2 },
                            { label: "Java", value: 3 },
                            { label: "Python", value: 4 },
                        ],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-left-0",
                    },
                },
                {
                    id: "editableDropdown",
                    label: "Editable Dropdown",
                    Field_Name: "editable dropdown",
                    fieldType: FormFieldTypes.EDITABLEDROPDOWN,
                    dataField: "editableDropdown",
                    fieldSetting: {
                        placeholder: "Please Select Data",
                        options: [
                            { label: "Option 1", value: 1 },
                            { label: "Option 2", value: 2 },
                            { label: "Option 3", value: 3 },
                        ],
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-left-0",
                    },
                },
                {
                    id: "addressLineId",
                    label: "Address Line",
                    Field_Name: "addressline",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "addressLineId",
                    fieldSetting: {
                        placeholder: "Please Select AddressLine",
                        allowSpace: true,
                        options: [],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-left-0",
                    },
                },
            ],
        },
        {
            title: "User Information Section",
            row: {},
            style: {
                sectionStyle: "col-lg-8 col-md-6",
            },
            wrapperTemplate: <div className=" row"></div>, // Wrapper HTML or Component
            rowGroup: [
                {
                    groupLabel: "Contact Information", // Group for contact fields
                    style: {
                        groupStyle: "col-lg-12 col-md-6 mb-2",
                    },
                    groupWrapper: <div className="form-card row"></div>, // Wrapper HTML or Component
                    fields: [
                        {
                            id: "userName",
                            label: "User Name1111111111",
                            Field_Name: "user name",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "userName",
                            fieldSetting: {
                                placeholder: "Please Enter User Name",
                                allowSpace: true,
                                isDisable: false,
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-6 col-md-6 validation-left-0",
                            },
                        },
                        {
                            id: "emailAddress",
                            label: "Email Address",
                            Field_Name: "email",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "emailAddress",
                            fieldSetting: {
                                placeholder: "Please Enter Email Address",
                                allowSpace: true,
                            },
                            validation: [
                                { type: validationTypes.REQUIRE },
                                { type: validationTypes.EMAIL },
                            ],
                            style: {
                                containerCss: "col-lg-6 col-md-6 validation-left-0",
                            },
                        },
                        {
                            id: "phone",
                            label: "Contact Number",
                            Field_Name: "phone number",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "phone",
                            fieldSetting: {
                                placeholder: "Please Enter Phone Number",
                                maskFormat: true,
                                allowSpace: true,
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-6 col-md-6 validation-left-0",
                            },
                        },
                    ],
                },
                {
                    groupLabel: "Personal Information", // Group for personal details
                    style: {
                        groupStyle: "col-lg-12 col-md-6 mb-2",
                    },
                    groupWrapper: <div className="form-card row"></div>,
                    fields: [
                        {
                            id: "firstName",
                            label: "First Name",
                            Field_Name: "first name",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "firstName",
                            fieldSetting: {
                                placeholder: "Please Enter First Name",
                                allowSpace: true,
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-6 col-md-6 validation-left-0",
                            },
                        },
                        {
                            id: "lastName",
                            label: "Last Name",
                            Field_Name: "last name",
                            fieldType: FormFieldTypes.INPUT,
                            dataField: "lastName",
                            fieldSetting: {
                                placeholder: "Please Enter Last Name",
                                allowSpace: true,
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-6 col-md-6 validation-left-0",
                            },
                        },
                    ],
                },
                {
                    groupLabel: "Personal Information", // Group for personal details
                    style: {
                        groupStyle: "col-lg-3 col-md-3",
                    },
                    groupWrapper: <div className="form-card row"></div>,
                    fields: [
                        {
                            id: "gender",
                            label: "Gender",
                            Field_Name: "gender",
                            fieldType: FormFieldTypes.RADIOBUTTON,
                            dataField: "gender",
                            fieldSetting: {
                                allowSpace: true,
                                options: [
                                    { value: "Male", label: "Male" },
                                    { value: "Female", label: "Female" },
                                ],
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-12 radioStyle col-md-12 validation-left-0",
                            },
                        },
                    ],
                },
                {
                    groupLabel: "Personal Information", // Group for personal details
                    style: {
                        groupStyle: "col-lg-9 col-md-9",
                    },
                    groupWrapper: <div className="form-card row"></div>,
                    fields: [
                        {
                            id: "checkbox1",
                            label: "Short ",
                            Field_Name: "first",
                            fieldType: FormFieldTypes.CHECKBOX,
                            dataField: "checkbox1",
                            fieldSetting: {
                                allowSpace: true,
                                subTitle: "Length : "
                            },
                            style: {
                                containerCss: "col-lg-3 col-md-3 double-label-sec",
                            },
                        },
                        {
                            id: "checkbox2",
                            label: "Medium",
                            Field_Name: "second",
                            fieldType: FormFieldTypes.CHECKBOX,
                            dataField: "checkbox2",
                            fieldSetting: {
                                allowSpace: true,
                                isDisable: true,
                                subTitle: ""
                            },
                            style: {
                                containerCss: "col-lg-3 col-md-3 double-label-sec",
                            },
                        },
                        {
                            id: "checkbox3",
                            label: "Not Medium",
                            Field_Name: "third",
                            fieldType: FormFieldTypes.CHECKBOX,
                            dataField: "checkbox3",
                            fieldSetting: {
                                allowSpace: true,
                                subTitle: ""
                            },
                            style: {
                                containerCss: "col-lg-3 col-md-3 double-label-sec",
                            },
                        },
                        {
                            id: "checkbox4",
                            label: "Loooonnnng",
                            Field_Name: "fourth",
                            fieldType: FormFieldTypes.CHECKBOX,
                            dataField: "checkbox4",
                            fieldSetting: {
                                allowSpace: true,
                                subTitle: ""
                            },
                            style: {
                                containerCss: "col-lg-3 col-md-3 double-label-sec",
                            },
                        },
                    ],
                },
            ],
        },
    ]

}